import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default function PushSubscriber() {
  const { user } = useAuth();
  const subscribedRef = useRef(false);

  useEffect(() => {
    if (!user || subscribedRef.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (!VAPID_PUBLIC_KEY) return;

    const subscribe = async () => {
      try {
        // iter100p: NON registrare più /sw.js qui — è già gestito da
        // useServiceWorkerUpdater. Usa solo la registrazione esistente.
        let registration = await navigator.serviceWorker.getRegistration('/sw.js');
        if (!registration) {
          // Se per qualche motivo non è ancora registrato, aspetta invece di
          // registrarlo qui: eviterebbe race condition col hook principale.
          registration = await navigator.serviceWorker.ready;
        }
        await navigator.serviceWorker.ready;

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
          });
        }

        await axios.post(`${API}/push/subscribe`, {
          subscription: subscription.toJSON()
        }, { withCredentials: true });

        subscribedRef.current = true;
      } catch (error) {
        console.error('Push subscription error:', error);
      }
    };

    // Delay to avoid blocking initial render
    const timer = setTimeout(subscribe, 3000);
    return () => clearTimeout(timer);
  }, [user]);

  return null;
}
